import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import qs from "query-string";

import {getCookie} from "@pg-mono/request";

export const kmApi = createApi({
    reducerPath: "kmApi",
    baseQuery: fetchBaseQuery({
        baseUrl: "/",
        credentials: "include",
        paramsSerializer: qs.stringify,
        prepareHeaders: (headers, api) => {
            const customCsrfToken = headers.get("X-CSRFToken");
            const csrf = getCookie("csrftoken");

            if (api.type === "mutation") {
                headers.set("Content-Type", "application/json");
            }

            if (api.type === "mutation" && !customCsrfToken && csrf) {
                headers.set("X-CSRFToken", csrf);
            }

            return headers;
        }
    }),
    endpoints: () => ({}),
    tagTypes: [
        "Preferences",
        "User",
        "List",
        "State",
        "FeatureFeedback",
        "ThreadList",
        "Thread",
        "Application",
        "PreleadList",
        "PreleadDetail",
        "HomeMatchPreferences",
        "Favorites",
        "ComparisonSettings",
        "OfferComparison",
        "Property",
        "RejectedPreleadsList",
        "PendingAcceptedPreleadList",
        "RegionPriceStats"
    ]
});
import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import qs from "query-string";

import {getCookie} from "@pg-mono/request";

export const kmApi = createApi({
    reducerPath: "kmApi",
    baseQuery: fetchBaseQuery({
        baseUrl: "/",
        credentials: "include",
        paramsSerializer: qs.stringify,
        prepareHeaders: (headers, api) => {
            const customCsrfToken = headers.get("X-CSRFToken");
            const csrf = getCookie("csrftoken");

            if (api.type === "mutation") {
                headers.set("Content-Type", "application/json");
            }

            if (api.type === "mutation" && !customCsrfToken && csrf) {
                headers.set("X-CSRFToken", csrf);
            }

            return headers;
        }
    }),
    endpoints: () => ({}),
    tagTypes: [
        "Preferences",
        "User",
        "List",
        "State",
        "FeatureFeedback",
        "ThreadList",
        "Thread",
        "Application",
        "PreleadList",
        "PreleadDetail",
        "HomeMatchPreferences",
        "Favorites",
        "ComparisonSettings",
        "OfferComparison",
        "Property",
        "RejectedPreleadsList",
        "PendingAcceptedPreleadList",
        "RegionPriceStats"
    ]
});
